import { render } from "./Alianzas.vue?vue&type=template&id=60d90cd6&scoped=true"
import script from "./Alianzas.vue?vue&type=script&lang=js"
export * from "./Alianzas.vue?vue&type=script&lang=js"

import "./Alianzas.vue?vue&type=style&index=0&id=60d90cd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d90cd6"]])

export default __exports__